import { useEffect, useState } from "react";
import { MenuCategoryRevenueStats, MenuItemRevenueStats } from "../../../../../services/stats/models";
import { getRevenueStatsByMenuCategoryId, getRevenueStatsByMenuItemId } from "../../../../../services/stats";

interface IFilter {
    fromDate: Date,
    toDate: Date,
    limit: number,
    menuId: number,
    menuCategoryId?: number
}
const useTopItemsStatsFetcher = (): [boolean, MenuItemRevenueStats[], IFilter, (v: IFilter) => void] => {
    const [isLoading, setIsLoading] = useState(true);
    const [result, setResult] = useState<MenuItemRevenueStats[]>([]);
    const [filter, setFilter] = useState<IFilter>();

    useEffect(() => {
        if(!filter) return;
        setIsLoading(true);
        (async () => {
            const res = await getRevenueStatsByMenuItemId(filter);
            if(!res.err){
                setResult(res.revenues);
            }
            setIsLoading(false);
        })()
    }, [filter])

    return [isLoading, result, filter, setFilter];
};


export default useTopItemsStatsFetcher;
